<template>
  <div class="main">
    <c-panel title="Classificação cutter" titleIcon="fas fa-hashtag">
      <!-- Item 3: "cadastrar o código cutter e uma descrição". -->
      <catalogo-crud tipo="cutter" rotuloNovo="NOVO CUTTER" nomeSingular="cutter"
                     placeholderBusca="Pesquisar por código ou descrição"
                     :campos="campos" :colunas="colunas" dialogLargura="520px"></catalogo-crud>
    </c-panel>
  </div>
</template>

<script>
import CatalogoCrud from '../catalogo/catalogo-crud.vue'

export default {
  components: { CatalogoCrud, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'codigo', label: 'Código cutter', obrigatorio: true, span: 8, max: 40 },
      { chave: 'descricao', label: 'Descrição', obrigatorio: true, span: 16, max: 191 }
    ],
    colunas: [
      { chave: 'codigo', label: 'Código', largura: '140px' },
      { chave: 'descricao', label: 'Descrição' }
    ]
  })
}
</script>
